import { render, staticRenderFns } from "./_message_reactions.vue?vue&type=template&id=13fb86b6&scoped=true&"
import script from "./_message_reactions.vue?vue&type=script&lang=js&"
export * from "./_message_reactions.vue?vue&type=script&lang=js&"
import style0 from "./_message_reactions.vue?vue&type=style&index=0&id=13fb86b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb86b6",
  null
  
)

export default component.exports